// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Hh-z","breadcrumbItem":"Ih-z"};